module.exports = __webpack_public_path__ + "img/favicon.49a9921e.png";